// Падеж
export const wordPad = (num, t, ta, tov) => {
    num = num % 100;
    if (num % 10 === 1 && (num < 10 || num > 20)) return t;
    else if ((num % 10 >= 2) && (num % 10 <= 4) && (num < 10 || num > 20)) return ta;
    else return tov;
};

// Время в часы, минуты, секунды
export const niceTime = (seconds) => {
    let minutes = Math.floor(seconds / 60);
    let hours = Math.floor(seconds / 3600);

    if (hours >= 1) return hours + ' час ' + (minutes - hours * 60) + ' мин';
    else if (minutes >= 1) return minutes + ' мин';
    else return seconds;
};

// Время в HH:MM:SS
export const formatTime = (sec, withHours = true, withMinutes = true, forceZeroes = false) => {
    let hours = Math.floor(sec / 3600);
    let minutes = Math.floor(sec / 60) - hours * 60;
    let seconds = sec - hours * 60 - minutes * 60;

    if (hours < 10 && forceZeroes) hours = '0' + hours;
    if (withHours) hours = hours + ':';
    else hours = '';

    if (minutes < 10 && (forceZeroes || withHours)) minutes = '0' + minutes;
    if (withMinutes) minutes = minutes + ':';
    else minutes = '';

    if (seconds < 10 && (forceZeroes || withMinutes)) seconds = '0' + seconds;

    return hours + minutes + seconds;
};

// Нули для больших чисел
export const numberWithSpaces = (x) => {
    let parts = x.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    return parts.join(".");
};

// Преобразовать первую букву в заглавную
export const capitalize = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
};

// Добавить нули перед числом
export const numberWithZeros = (num, amount = 2) => {
    return '0'.repeat(amount - String(num).length) + num;
};

// Проверка на INT
export const isInt = (value) => {
    return !isNaN(value) && (function(x) { return (x | 0) === x; })(parseFloat(value))
};

// DATETIME в VK TIME
export const vkTime = (datetime) => {
    let moment = require('moment');
    let date = moment(datetime);

    let day = date.format('D');
    let month = date.format('M');
    let time = date.format('H:mm');
    let monthsStr = ['янв', 'фев', 'мар', 'апр', 'мая', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'];


    let THIS_YEAR = moment().format('YYYY');

    let yr;
    if (THIS_YEAR !== date.format('YYYY')) {
        yr = ' ' + date.format('YYYY') + ' ';
    } else {
        yr = '';
    }


    let TODAY = moment().clone().startOf('day');
    let YESTERDAY = moment().clone().subtract(1, 'days').startOf('day');
    let YESTERDAY_TWICE = moment().clone().subtract(2, 'days').startOf('day');

    let dt;
    if (date.isSame(TODAY, 'd')) {
        dt = 'сегодня';
    } else if (date.isSame(YESTERDAY, 'd')) {
        dt = 'вчера';
    } else if (date.isSame(YESTERDAY_TWICE, 'd')) {
        dt = 'позавчера';
    } else {
        dt = day + ' ' + monthsStr[month - 1] + yr;
    }

    return dt + ' в ' + time;
};


// WEBPACK FOOTER //
// ./src/js/services/_functions.js